
export class Contact {

  prefix: string;
  number: string;

  constructor(prefix: string, number: string) {

    this.number = number;
    this.prefix = prefix;
  }

  getTableMessage() {

    return "+" + this.prefix + " " + this.number;
  }

  getCompleteNumber(): string {

    return "+" + this.prefix + this.number;
  }
  
}
